import { useI18n, LANGS } from "@/lib/i18n";
import { Globe } from "@phosphor-icons/react";

export default function LangSwitcher({ compact = false }) {
  const { lang, setLang } = useI18n();
  return (
    <div className={`inline-flex items-center gap-1.5 ${compact ? "" : ""}`}>
      <Globe size={16} className="text-slate-500" />
      <select data-testid="lang-switcher" value={lang} onChange={(e) => setLang(e.target.value)}
        className="text-xs font-semibold bg-transparent border border-slate-200 rounded-md px-1.5 py-1 hover:border-slate-400 cursor-pointer">
        {LANGS.map((l) => (<option key={l.code} value={l.code}>{l.label}</option>))}
      </select>
    </div>
  );
}
